import { createSelector } from 'reselect';

import { AppState } from '../../store/rootReducer';

const getLocale = (state: AppState) => state.languageProvider.locale;

export const getLocaleSelector = createSelector(getLocale, locale => locale);
